import { render, staticRenderFns } from "./FormKTCInstallmentPlan.vue?vue&type=template&id=6b370cc4&scoped=true&"
import script from "./FormKTCInstallmentPlan.vue?vue&type=script&lang=js&"
export * from "./FormKTCInstallmentPlan.vue?vue&type=script&lang=js&"
import style0 from "./FormKTCInstallmentPlan.vue?vue&type=style&index=0&id=6b370cc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b370cc4",
  null
  
)

export default component.exports